/* global axios */
import ApiClient from './ApiClient';

class WhatsappTemplatesAPI extends ApiClient {
  constructor() {
    super('whatsapp_templates', { accountScoped: true });
  }

  create(inboxId, templateData) {
    return axios.post(this.url, {
      inbox_id: inboxId,
      ...templateData,
    });
  }
}

export default new WhatsappTemplatesAPI();
